<div class="customer-grid-table">
  <!-- <ng-container *ngIf="this.data"> -->
  <kendo-grid [kendoGridBinding]="data" [pageSize]="5" [sortable]="true" [pageable]="true" [loading]="isLoading"
    [reorderable]="true" [resizable]="true" [height]="300" [columnMenu]="{ filter: true }">
    <div class="flair-column"></div>

    <kendo-grid-column field="customerName" title="Customer Name" [width]="220">
      <ng-template kendoGridCellTemplate let-dataItem>
        <app-stateful-internal-link
          class="edit-link"
          [text]="dataItem.customerName"
          (click)="this.gotoEditCustomer(dataItem.clientCustomerId)"
        >
        </app-stateful-internal-link>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="legalCustomerName"
      title="Legal Customer Name"
      [width]="220"
    >
    </kendo-grid-column>

    <kendo-grid-column
      field="customerRefNumber"
      title="Customer ID"
      [width]="200"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <span>{{dataItem.customerRefNumber}}</span>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="status" title="Status" [width]="160">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div kendoTooltip filter=".status-wrapper" [tooltipWidth]="200" position="left">
          <div class="status-wrapper" [title]="dataItem.statusDescription">
            <ng-container *ngIf="!dataItem.requestsAdditionalCreditInfo">
              <app-stateful-internal-link 
                class="edit-link" 
                [text]="dataItem.status"
                (click)="this.gotoEditCustomer(dataItem.clientCustomerId)">
              </app-stateful-internal-link>
            </ng-container>

            <ng-container *ngIf="dataItem.requestsAdditionalCreditInfo">
              <app-stateful-internal-link 
                class="edit-link" 
                [text]="dataItem.status"
                (click)="this.goToAdditionalCreditInfo(dataItem.clientCustomerId, dataItem.customerName)"
              ></app-stateful-internal-link>
              <div class="action-required-button-wrapper">
                <app-stateful-primary-button
                  [text]="'Click Here'"
                  (click)="this.goToAdditionalCreditInfo(dataItem.clientCustomerId, dataItem.customerName)"
                  colorCssClass="orange"
                ></app-stateful-primary-button>
              </div>
            </ng-container>
          </div>
        </div>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="delete" title="Delete" [width]="100">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="delete">
          <img src="../../../../assets/images/Icon material-delete.svg" alt="Delete {{ dataItem.customerName }}"
            (click)="this.deleteCustomer(dataItem.clientCustomerId)"
            (keydown.Space)="this.deleteCustomer(dataItem.clientCustomerId)"
            (keydown.enter)="this.deleteCustomer(dataItem.clientCustomerId)" tabindex="0" />
        </div>
      </ng-template>
    </kendo-grid-column>
    
    <ng-template kendoGridDetailTemplate let-dataItem>
      <div class="extension-container">
        <div class="extention" *ngIf="dataItem.customerAddress">
          <p>
            <strong>IsFederal: </strong>{{ dataItem.customerAddress?.isFederal }}
          </p>
          <p>
            <strong>Monthly Invoice Amount:</strong> ${{
            dataItem.customerAddress?.monthlyInvoiceAmount
            }}
          </p>
          <p>
            <strong>Monthly Invoice Term:</strong>
            {{ dataItem.customerAddress?.invoiceTerm }} days
          </p>
        </div>
        <div class="extention" *ngIf="dataItem.customerAddress">
          <p>
            <strong>Billing Address: </strong>{{ dataItem.customerAddress?.billingAddress }}
          </p>
          <p>
            <strong>Headquarter Address: </strong>
            {{
            (dataItem.customerAddress?.headquartersAddress )
            ? dataItem.customerAddress?.headquartersAddress
            : "N/A"
            }}
          </p>
          <p style="display: flex;">
            <strong style="padding-right: 4px;">Additional Info Provided:</strong>
            <app-stateful-internal-link 
              class="edit-link" 
              [text]="'View Here'"
              [bypassNav]="true"
              (click)="this.goToAdditionalCreditInfo(dataItem.clientCustomerId, dataItem.customerName)"
            ></app-stateful-internal-link>
          </p>
        </div>
      </div>
    </ng-template>
    <ng-template kendoGridDetailTemplate>
      <div class="k-loading-color"></div>
      <div class="loading-container">
        <kendo-loader type="converging-spinner" size="large"></kendo-loader>
      </div>
    </ng-template>
    <kendo-grid-messages noRecords=""> </kendo-grid-messages>
  </kendo-grid>
  <!-- </ng-container> -->
</div>